
import { Component } from 'react';
import { Image } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';

interface Project {
  title: string;
  url?: string;
  description: string;
  stack: string[];
  key: number;
  live: boolean;
  videoSrc?: string;
  imagesSrc?: string[];
}
interface ProjectsData {
  type: string;
  projects: Project[];
  key: number;
}
class Projects extends Component {
  render() {
    const projectData: ProjectsData[] = [
      {
        type: 'Word Games',
        key: 0,
        projects: [
          {
            title: 'MishMash',
            key: 0,
            url: 'https://mishmash.day',
            description: 'A word game played by thousands. I just want to be the next Wordle, and I don\'t think that\'s too much to ask!',
            live: true,
            imagesSrc: ['./mishmash.png'],
            stack: [
              'ExpressJS',
              'Typescript',
              'Socket.io',
            ]
          }, 
          {
            title: 'Mishmath',
            key: 1,
            description: 'Mishmash, but for math nerds.',
            live: true,
            imagesSrc: ['./mishmath.png'],
            stack: [
              'ExpressJS',
              'Typescript',
            ]
          },
          {
            title: 'Mishmash Lightning',
            key: 2,
            url: 'https://mishmash.day/lightning',
            description: 'A different take on the original Mishmash. You get 45 seconds to unscramble as many four-letter words as you can. Personally, my favorite. Critically, played by few.',
            live: true,
            imagesSrc: ['./lightning.png'],
            stack: [
              'ExpressJS',
              'Typescript',
            ]
          },
          {
            title: 'Mishmash: The Synonym Challenge',
            key: 3,
            url: 'https://mishmash.day/smishmash',
            imagesSrc: ['./smishmash.png'],
            description: 'I had an aunt who refused to play MishMash because the timed aspect frustrated her. So I tried to make one that wouldn\'t involve being timed. I spent very little time on it, and hate playing it because the synonym wordbank I use is...questionable. I could leave this one off my resume, but I\'m trusting you here. Plus, if you clicked on the others, they\'ll take you there anyway eventually.',
            live: true,
            stack: [
              'ExpressJS',
              'Typescript',
            ]
          }
        ]
      },
      {
        type: 'Software <-------> Hardware',
        key: 4,
        projects: [
          {
            title: 'Surf API',
            live: true,
            key: 0,
            description: 'Pulls tide and surf data from a few APIs and displays on an LED screen. This was my most involved Python project to date. I had to get creative to avoid exceeding free-tier limits, so I set up a wave API to request and aggregate the information on a cron that then communicates with the chip on the hardware.',
            videoSrc: './surf-box.mp4',
            stack: [
              'Circuit Python',
              'Matrix Portal S3',
              'open-meteo API',
              'NOAA API'
            ]
          },
          {
            title: 'T9 Keyboard',
            live: true,
            key: 1,
            videoSrc: './t9-mod-demo.mp4',
            description: 'Uses a T9 library with some custom modifications to build an accessible keyboard. I had to learn some basic circuitry in Fritzing which took quite some time. Leverages the project here as the starting point: https://t9-library-generator.uk.r.appspot.com/assembly/QTPY_2040',
            stack: [
              'Circuit Python',
              'Adafruit RP2040',
              'Fritzing'
            ]
          }
        ]
      },
      {
        type: 'Side Hustles',
        key: 2,
        projects: [
          {
            title: 'Leaderboard',
            url: '',
            live: false,
            description: 'A site where users can create an account and aggregate their daily game scores. Create a group for you and your friends, add the games you play each day, and upload your scores to track stats over time.',
            key: 6,
            imagesSrc: [
              './leaderboard-two.png',
              './leaderboard-one.png',
            ],
            stack: [
              'Supabase',
              'NextJS',
            ]
          },
          {
            title: 'LivnList',
            live: false,
            key: 4,
            description: 'Based in React, I worked with a team on the Front End building out a webapp that would make it easier to coordinate plans.',
            stack: [
              'React',
              'Typescript',
              'JWT',
            ]
          },
          {
            title: 'Chat in the Box',
            key: 5,
            live: false,
            description: 'First in React, then in Vue - this was an online webapp keyboard meant to be used as an accessibility feature on an iPad for a friend who can\'t type on modern keypads.',
            stack: [
              'React',
              'Vue (rewrite)',
              'Twilio API',
              'ExpressJS',
            ]
          },
        ]
      },
      {
        type: 'Efficiency and Automation',
        key: 1,
        projects: [
          {
            title: 'Research Formatter',
            key: 2,
            live: false,
            description: 'Used by students at HBS. A node script that does some fancy formatting. It brought task time down from ten hours to less than a second.',
            stack: [
              'NodeJS',
            ]
          }, 
          {
            title: 'Class Sign Up',
            key: 3,
            live: true,
            description: 'A script to make sure you don\'t miss sign-up for your favorite work out class',
            stack: [
              'Puppeteer',
            ]
          },
        ]
      }
    ]
    return (
      <div className="Projects">
        {
          projectData.map(({ type, projects, key }) =>
          <div key={key} className="project-type-container">
            <h3>{type}</h3>
            <div className="projects-container">
            {
              projects.map(({title, live, description, stack, url, key: projectKey, videoSrc, imagesSrc}) =>
                <div key={projectKey} className="project-container">
                  <p className="project-title">{live && url ? <a className="project-link" target="_blank" href={url}>{title}</a> : title}</p>
                  <p className="project-non-title project-stack stack-title">{stack.join(', ')}</p>
                  {videoSrc ? <video controls className="project-video" autoPlay={true} muted={true}><source src={videoSrc}></source></video> : <span></span>}
                  {imagesSrc && imagesSrc.length && imagesSrc.map(imageSrc => (
                    <Image 
                      src={imageSrc}
                      className='project-img'
                    />
                  ))}
                  <p className="project-non-title description">{description}</p>
                  <p>Live: {live ? 'yes' : 'no'}</p>
                </div>
              )
            }
            </div>
          </div>
          )
        }
      </div>
    );
  }
}

export default Projects;
